const clearStorage = () => localStorage.clear();

const getItem = key => {
  if (!localStorage) return;

  try {
    return JSON.parse(localStorage.getItem(key));
  } catch (error) {
    // eslint-disable-next-line
    console.error(`Error getting item ${key} from localStorage`, error);
  }
};

const storeItem = (key, item) => {
  if (!localStorage) return;

  try {
    return localStorage.setItem(key, JSON.stringify(item));
  } catch (error) {
    // eslint-disable-next-line
    console.error(`Error storing item ${key} to localStorage`, error);
  }
};

const removeItem = key => {
  if (!localStorage) return;

  try {
    return localStorage.removeItem(key);
  } catch (error) {
    // eslint-disable-next-line
    console.error(`Error removing item ${key} to localStorage`, error);
  }
};

module.exports = {
  clearStorage,
  getItem,
  storeItem,
  removeItem,
};



// WEBPACK FOOTER //
// ../shared/optilit-frontend-helpers/src/localstorage.js